import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import { isApiResponse } from '../helpers/utils.js';
import TicketDetailTable from './TicketDetailTable.jsx';
import './TicketReport.css';
import { agingColumns, numericColumnTargets, ageBucketForColumn } from './agingBuckets.js';

class StoreTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedTeam: null,
      selectedAgeBucket: null
    };
  }

  componentDidMount() {
    if (this.props.shouldLoadData) {
      this.get_filtered_open_aging_store();
      this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldLoadData && !prevProps.shouldLoadData) {
      this.get_filtered_open_aging_store();
    } else if (
      prevProps.merchantID !== this.props.merchantID ||
      prevProps.chainID !== this.props.chainID ||
      prevProps.storeID !== this.props.storeID ||
      prevProps.yestSend !== this.props.yestSend ||
      prevProps.todSend !== this.props.todSend ||
      prevProps.issue_type !== this.props.issue_type ||
      prevProps.cf_issue_sub_category !== this.props.cf_issue_sub_category ||
      prevProps.city !== this.props.city ||
      prevProps.channel !== this.props.channel ||
      prevProps.product !== this.props.product ||
      prevProps.team !== this.props.team ||
      prevProps.ageing !== this.props.ageing ||
      prevProps.aso_assignment !== this.props.aso_assignment
    ) {
      this.get_filtered_open_aging_store();
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#merchantAgingTable')) {
      $('#merchantAgingTable').DataTable().clear().destroy();
    }
  }

  get_filtered_open_aging_store() {
    var that = this;
    if (this.props.shouldLoadData) {
      const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        chain: this.props.chainID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        ageing: this.props.ageing || [],
        aso_assignment: this.props.aso_assignment || [],
        group_by: 'store',
        report_code: 'open_tickets_aging_store_wise',
        download: 0
      };

      isApiResponse(false);

      if ($.fn.DataTable.isDataTable('#merchantAgingTable')) {
        $('#merchantAgingTable').DataTable().clear().destroy();
      }

      $('#merchantAgingTable').DataTable({
        order: [],
        processing: true,
        serverSide: true,
        bDestroy: true,
        paging: true,
        pageLength: 5,
        bInfo: false,
        autoWidth: true,
        responsive: false,
        searching: true,
        lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
        ajax: {
          url: config.get('API_URL') + '/ServiceReport/open_tickets_aging_v2',
          type: 'POST',
          data: postData,
          dataSrc: function (json) {
            isApiResponse(true);
            that.setState({ isChange: false });
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader('Authorization', localStorage.usertoken);
          },
          error: function (data) {
            isApiResponse(true);
            alert('Failed to load data. Please try again');
            console.log('error', data);
          },
          complete: function (data) {
            isApiResponse(true);
          }
        },
        columns: agingColumns('Store', this.props.ageing, 'Store Name'),
        columnDefs: [
          {
            targets: 0,
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap width-220'>${val}</div>`;
            }
          },
          {
            targets: numericColumnTargets(this.props.ageing),
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0) {
                $(td).css({ cursor: 'pointer' });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          }
        ],
        headerCallback: function (thead) {
          $(thead).find('th').addClass('merchant-header-default');
        }
      });
    }
  }

  handleCellClick(rowData, colIndex) {
    const storeName = rowData['Store'];
    const ageBucket = ageBucketForColumn(this.props.ageing, colIndex);
    this.setState({
      showDetails: true,
      selectedTeam: storeName,
      selectedAgeBucket: ageBucket
    });
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedTeam: null,
      selectedAgeBucket: null
    });
  }

  render() {
    const { showDetails, selectedTeam, selectedAgeBucket } = this.state;
    return (
      <div className="merchant-tab-content service-report">
        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
          <table id="merchantAgingTable" className="table table-striped table-hover">
            <thead></thead>
            <tbody />
          </table>
        </div>

        {showDetails && (
          <TicketDetailTable
            key={`${selectedTeam}-${selectedAgeBucket}`}
            tableId="openAgingStoreDetailsTable"
            apiUrl="/ServiceReport/open_tickets_aging_details_v2"
            postData={{
              start_date: this.props.yestSend,
              end_date: this.props.todSend,
              download: 0,
              group_by: 'store',
              group_value: selectedTeam,
              age_bucket: selectedAgeBucket,
              merchant: this.props.merchantID || [],
              chain: this.props.chainID || [],
              store: this.props.storeID || [],
              issue_category: this.props.cf_issue_sub_category || [],
              city: this.props.city || [],
              channel: this.props.channel || [],
              product: this.props.product || [],
              team: this.props.team || [],
              ageing: this.props.ageing || [],
              aso_assignment: this.props.aso_assignment || []
            }}
            title={`Ticket Details - ${selectedTeam}`}
            columnType={selectedAgeBucket}
            objectType={this.props.object_type}
            onClose={() => this.closeDetails()}
            downloadConfig={{
              fn: 'open_tickets_aging_store_wise_details.csv.gz',
              url: '/service_reports/open_tickets_aging_details_v2',
              filters: {
                start_date: this.props.yestSend,
                end_date: this.props.todSend,
                download: 1,
                report_code: 'open_tickets_aging_store_wise_details',
                group_by: 'store',
                group_value: selectedTeam,
                age_bucket: selectedAgeBucket,
                merchant: this.props.merchantID,
                chain: this.props.chainID || [],
                store: this.props.storeID,
                issue_category: this.props.cf_issue_sub_category,
                city: this.props.city,
                channel: this.props.channel,
                product: this.props.product,
                team: this.props.team,
                ageing: this.props.ageing,
                aso_assignment: this.props.aso_assignment
              },
              timeout: 180
            }}
          />
        )}
      </div>
    );
  }
}

export default StoreTab;
